import React, { useState, useEffect } from 'react'
import { Box, Select, MenuItem, Container, Button, Card, Grid, Typography, Menu, Avatar, IconButton, Tooltip } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import FreeRideStepper from '../../Component/FreeRideStepper/FreeRideStepper'
import DriveWithUsStepper from '../../Component/DriveWithUsStepper/DriveWithUsStepper'
import PartnerWithUs from '../../Component/PartnerWithUsStepper/PartnerWithUsStepper'
import ButtonC from '../../Component/ButtonC/ButtonC'
import { IMAGES_URL } from 'Utils/URLs'
import VideoPlayer from 'Component/VideoPlayer'

const video = {
  type: 'video',
  sources: [
    {
      src: require("../../assets/Videos/English/v2.mp4"),
      type: 'video/mp4',
      size: 720,
    }
  ],
}
const spenishvideo = {
  type: 'video',
  sources: [
    {
      src: require("../../assets/Videos/Spenish/Video02_Draft04-Spanish.mp4"),
      type: 'video/mp4',
      size: 720,
    }
  ],
}


const Main = () => {
  const navigate = useNavigate()
  const [driveType, setDriveType] = useState(0)
  const [show, setShow] = useState(false)
  const token = localStorage.getItem("token")
  const user = JSON.parse(localStorage.getItem("user"))
  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleLogout = () => {
    localStorage.clear()
    navigate("/driver_forms")
  }
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };


  useEffect(() => {

    const handlePopstate = () => {

      setDriveType('');
    };

    window.addEventListener('popstate', handlePopstate);

    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  const HandleNext = (route) => {
    setShow(true)
    setDriveType(route)
  }


  return (
    <>

      <div className='main-container' >
        <Container maxWidth={"lg"} >
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} >
            {/* <Box mt={{sm:1,xs:2}}  >
    <img src="/driver_forms/assets/images/logo192.png" className='logo'  />
    </Box> */}
            {/* <Box mt={1} >
    <ButtonC title="Home" />
    </Box> */}
            {/* <Button sx={{bgcolor:"#97c11e","&:hover":{bgcolor:"#021b38"}}} variant="contained" size="large" >Home</Button> */}
          </Box>
          {/* <Card sx={{bgcolor:"rgba(255,255,255,0.8)",marginTop:2,marginBottom:{sm:0,xs:2}}}  className='main-card'   >
        
       <Grid container >
        <Grid xl={6} lg={6} md={6}   sx={{display:"flex",alignItems:"center",flexDirection:"column",pt:10,px:2}}  >
       <h1 className='main-title' ><span style={{ color: "#021b38" }}>GET THE BEST MEDICAL TRANSPORT SERVICE NYC<br /></span></h1>
          <Box sx={{width:"100%"}} mx={{lg:5,sm:2}}  >
          {

            show?

          driveType==="get-free-ride"?
        <FreeRideStepper SetValue={(e)=>setShow(e)} />
      :
      driveType==="drive-with-us"?
      <DriveWithUsStepper SetValue={(e)=>setShow(e)} />
      :
      driveType==="partner-with-us"?
      <PartnerWithUs SetValue={(e)=>setShow(e)} />:""
      :
      <Box sx={{marginX:{lg:5,sm:5,xs:2}}}  >
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            sx={{ borderColor:"#FFF"}}
            placeholder='Select Driving Type'
            fullWidth
             defaultValue={0}
            value={driveType}
            onChange={(e)=>setDriveType(e.target.value)}
          >

            <MenuItem selected={true} disabled value={0}>Select Driving Type</MenuItem>
            <MenuItem value={"get-free-ride"}>Get Free Ride</MenuItem>
            <MenuItem value={"drive-with-us"}>Drive With Us</MenuItem>
            <MenuItem value={'partner-with-us'}>Partner With Us</MenuItem>
          </Select>
          <Box textAlign={"center"} mt={3} display={driveType===0?"none":"block"} >
            <Button onClick={HandleNext} sx={{bgcolor:"#97c11e","&:hover":{bgcolor:"#021b38"}}} variant="contained" >Next</Button>
          </Box>
          </Box>
         }
        </Box>
        </Grid>
        <Grid xl={6} lg={6} md={6} xs={12}  mt={{base:0,md:0,xs:5}}   >
        <img src="/driver_forms/assets/images/main.jpeg" className='main-img'  />
        </Grid>
        </Grid>
        </Card> */}
          <Grid container >
            <Grid item xs={6} md={7} >

              <Box sx={{ display: "flex", justifyContent: { xs: "center", md: 'end' } }} mt={3}  >
                <a href='https://getbettertransportation.com/' > <img src='/driver_forms/assets/images/output-onlinepngtools.png' className='logo' /></a>

              </Box>
            </Grid>
            <Grid item xs={6} md={5} mt={{ xs: 0, md: 0 }} >
              <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", height: "100%" }}   >
                {token === null ?
                  <Button variant="contained" sx={{
                    width: { xs: "100%", md: "50%" },
                    padding: "9px 20px",
                    borderRadius: 5,
                    backgroundColor: "green",
                    fontWeight: "900",
                    fontSize: 14,
                    "&:hover": {
                      backgroundColor: "#016801"
                    }
                  }} onClick={() => navigate("/driver_forms/login")} >Login</Button>
                  :
                  <Box sx={{ flexGrow: 0 }}>
                    <Tooltip title="Open settings">
                      <Box sx={{ backgroundColor: "#FFF", p: 1, borderRadius: 50 }} >
                        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                          <Avatar sx={{ height: 50, width: 50 }} alt={user?.name} src={user?.profile_pic ? `${user?.profile_pic}` : ""} />
                        </IconButton>
                      </Box>
                    </Tooltip>
                    <Menu
                      sx={{ mt: "45px" }}
                      id="menu-appbar"
                      anchorEl={anchorElUser}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      open={Boolean(anchorElUser)}
                      onClose={handleCloseUserMenu}
                    >

                      <MenuItem onClick={() => navigate("/driver_forms/profile")}>
                        <Typography textAlign="center">Profile</Typography>
                      </MenuItem>
                      <MenuItem onClick={handleLogout}>
                        <Typography textAlign="center">Logout</Typography>
                      </MenuItem>

                    </Menu>
                  </Box>
                }
              </Box>
            </Grid>
          </Grid>
          {driveType === "drive-with-us" ?
            <Grid container mb={2}   >
              <Grid xs={12} md={3} order={{xs:2,md:1}} >
                <VideoPlayer
                  sources={video}
                  options={{
                    controls: [
                      'play',
                      'current-time',
                      // 'duration',
                      "progress",
                      'mute',
                      'volume',
                      'fullscreen',

                    ],
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6} order={1}  >


                <Box mt={5}  mb={5}   >
                  <Typography className='main-title' sx={{ fontSize: 32, textAlign: "center", fontWeight: "bolder", color: "#FFF", letterSpacing: 5, lineHeight: 1, textTransform: "uppercase" }} >Get the best medical transportation in  <br /> new york!</Typography>
                </Box>
              </Grid>
              <Grid xs={12} md={3} order={3} mt={{xs:3,md:0}} >
                <VideoPlayer
                  sources={spenishvideo}
                  options={{
                    controls: [
                      'play',
                      'current-time',
                      // 'duration',
                      "progress",
                      'mute',
                      'volume',
                      'fullscreen',

                    ],
                  }}
                />
              </Grid>
            </Grid>
            :
            <Box mt={11} mb={5} >
              <Typography className='main-title' sx={{ fontSize: 43, textAlign: "center", fontWeight: "bolder", color: "#FFF", letterSpacing: 5, lineHeight: 1, textTransform: "uppercase" }} >Get the best medical transportation in  <br /> new york!</Typography>
            </Box>
          }

          {

            show ?

              driveType === "get-free-ride" ?
                <FreeRideStepper SetValue={(e) => setShow(e)} />
                :
                driveType === "drive-with-us" ?
                  <DriveWithUsStepper SetValue={(e) => setShow(e)} />
                  :
                  driveType === "partner-with-us" ?
                    <PartnerWithUs SetValue={(e) => setShow(e)} /> : ""
              :
              < Box  sx={{mt:{sm:2,md:5}}} component="div" className='btn-box' >
                <Grid container justifyContent="center" spacing={{ xs: 0, sm: 0, md: 2 }} >
                  <Grid item xs={12} md={12} display="flex" justifyContent="center"  >
                    <Button variant="contained" sx={{
                      width: { xs: "100%", md: "50%" },
                      padding: "9px 0px",
                      borderRadius: 50,
                      backgroundColor: "red",
                      fontWeight: "900",
                      fontSize: 16,
                      "&:hover": {
                        backgroundColor: "#d30606"
                      }
                    }} onClick={() => HandleNext("drive-with-us")} >Drive With Us...</Button>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6} md={6} sx={{mt:{xs:2,md:5}}} display={{ xs: "block", md: "flex" }} justifyContent="end" >
                    <Button variant="contained" sx={{
                      width: { xs: "100%", md: "50%" },
                      padding: "9px 0px",
                      borderRadius: 50,
                      backgroundColor: "green",
                      fontWeight: "900",
                      fontSize: 16,
                      "&:hover": {
                        backgroundColor: "#016801"
                      }
                    }} onClick={() => HandleNext("get-free-ride")} >Get Free Ride</Button>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={6} md={6} sx={{mt:{xs:2,md:5}}}   >
                    <Button variant="contained" sx={{
                      width: { xs: "100%", md: "50%" },
                      padding: "9px 0px",
                      borderRadius: 50,
                      backgroundColor: "green",
                      fontWeight: "900",
                      fontSize: 16,
                      "&:hover": {
                        backgroundColor: "#016801"
                      }
                    }} onClick={() => HandleNext("partner-with-us")} >Partner with us</Button>
                  </Grid>
                </Grid>
              </Box>
          }
        </Container>
      </div >
    </>
  )
}

export default Main